import Loading from './Loading';

export default Loading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-loading/es/index.js
// module id = 106
// module chunks = 0